<template>

    <router-link to="/"></router-link> 
 
  <router-view/>
</template>
<script>

export default {
  data() {
    return {
      zwtab: 1,
    }
  },
  mounted() {
    this.bodyScale()
    window.onresize = () => {
      return (() => {
        // 页面变化监听尺寸
        this.bodyScale()
      })()
    }

  },

  methods: {


    // 获取当前屏幕尺寸函数
    
    bodyScale() {
      let devicewidth = document.documentElement.clientWidth//获取当前分辨率下的可视区域宽度
      let scale = devicewidth / 1920 // 分母——设计稿的尺寸
      document.body.style.zoom = scale//放大缩小相应倍数
      console.log(document.body.style.zoom,'放大缩小相应倍数');
    }
  },
  created() {
  
   
  },
 
}
</script>
<style>

</style>
